import SkgLogo from './skg-logo-white.svg'
import { BsChevronLeft } from 'react-icons/bs'
import { IoIosCart } from 'react-icons/io'
import React, { useState } from 'react';
import { animated, config, useSpring, useTransition } from '@react-spring/web'
import { useAppState } from '../../providers/app-state';
import OrderInfo from '../order-info';
import { FaHome } from 'react-icons/fa';

const MobileNav = ({ backFn, lockBackButton, icon, prevStepTitle }) => {
    const [cartOpen, setCartOpen] = useState(false)

    const cartSpring = useSpring({
        config: config.gentle,
        translateX: cartOpen ? "0vw" : "-100vw",
        zIndex: cartOpen ? 10 : 0,
        immediate: key => key === 'zIndex'
    })

    const transition = useTransition(icon, {
        from: {
            scale: 0
        },
        enter: {
            scale: 1
        }
    })

    const { state } = useAppState();

    return (
        <div
            className='bg-skgBlue py-2'
        >
            <div
                className='max-w-1400 py-1 flex justify-between items-center h-14 mx-auto pl-4 pr-4'
            >
                <a
                    className="w-44"
                    href={process.env.REACT_APP_WEBSITE_URL}
                >
                    <img
                        src={SkgLogo}
                        alt="skorstensgaard logo"
                    />
                </a>
                <div
                    className='flex flex-row items-center'
                >
                    {
                        lockBackButton
                            ? (
                                <a
                                    className='text-white flex items-center cursor-pointer space-x-1 relative'
                                    href={process.env.REACT_APP_WEBSITE_URL}
                                >
                                    <FaHome
                                        className="block md:absolute text-white md:text-[rgba(255,255,255,.2)] right-0 text-[30px] md:text-[90px]"
                                    />
                                    <BsChevronLeft
                                        color="white"
                                        size={20}
                                        className="ml-4 hidden md:block"
                                    />
                                    <span
                                        className='text-xs font-light hidden md:block x-10'
                                    >
                                        Tilbage til forsiden
                                    </span>
                                </a>
                            )
                            : (
                                <div
                                    className='text-white flex items-center cursor-pointer space-x-1 relative'
                                    onClick={backFn}
                                >
                                    {
                                        transition((style, item) => {
                                            return (
                                                <animated.div
                                                    style={style}
                                                    className="hidden md:block md:absolute text-white md:text-[rgba(255,255,255,.2)] right-0"
                                                >
                                                    {
                                                        React.cloneElement(item, {
                                                            className: "text-[30px] md:text-[90px]",
                                                        })
                                                    }
                                                </animated.div>
                                            )
                                        })
                                    }
                                    <BsChevronLeft
                                        color="white"
                                        size={20}
                                        className="ml-4"
                                    />
                                    <div
                                        className='text-xs font-light space-x-1'
                                    >
                                        <span>
                                            Tilbage
                                        </span>
                                        <span
                                            className="hidden md:inline-block"
                                        >
                                            til {prevStepTitle}
                                        </span>
                                    </div>
                                </div>
                            )
                    }
                    <div
                        className='relative lg:hidden'
                    >
                        <div
                            className='absolute top-0 -right-1 -mt-2 border pt-1 rounded-full w-4 h-4 text-skgRed border-skgRed flex items-center justify-center text-xs'
                        >
                            {
                                state.selectedRepairs.length
                            }
                        </div>
                        <IoIosCart
                            color={cartOpen ? "#ef4136" : "white"}
                            size={25}
                            className="ml-4"
                            onClick={() => setCartOpen(p => !p)}
                        />
                    </div>
                </div>
            </div>
            <animated.div
                className=" bg-white shadow-lg text-skgBlue absolute w-full"
                style={cartSpring}
            >
                <OrderInfo />
            </animated.div>
        </div>
    )
}

export default MobileNav;